import { render, staticRenderFns } from "./basketball-icon.vue?vue&type=template&id=3645b9e5"
import script from "./basketball-icon.vue?vue&type=script&lang=js"
export * from "./basketball-icon.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports